import { atom } from "recoil";

export const numState = atom({
  key: "buildingNum",
  default: null,
});
